module.exports = __webpack_public_path__ + "760c461a07383dd119225dbb6d722f02.jpg";